<div class="custom-modal">
    <div class="header">
        <h1 mat-dialog-title>
            Solicitação de prorrogação de SLA
        </h1>
        <mat-icon mat-dialog-close="cancel">close</mat-icon>
    </div>
    <mat-divider></mat-divider>
    <div mat-dialog-content>
        <mat-card>
            <mat-card-header class="header-padrao">
                <mat-card-title>
                   Dados da recepção do manifesto
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="container">
                    <div class="itemNumero">Número: {{ numero }}</div>
                    <div class="itemDataBaixa">Data Baixa: {{ dataBaixa }}</div>
                    <div>Data SLA Atual: {{ dataSLAAtual }}</div>
                </div>          
            </mat-card-content>
        </mat-card>

        <mat-card>
            <mat-card-header class="header-padrao">
                <mat-card-title>
                   Dados da solicitação de prorrogação
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <form class="filtros-header" [formGroup]="form">
                    <mat-form-field>
                        <mat-label>Data Final</mat-label>
                        <input matInput autocomplete="off" maskDate [matDatepicker]="dataFinal"
                            formControlName="dataFinal">
                        <mat-datepicker-toggle matSuffix [for]="dataFinal"></mat-datepicker-toggle>
                        <mat-datepicker #dataFinal></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field class="horaFinal">
                        <input matInput type="time" class="bg-none" formControlName="horaFinal" placeholder="Hora Final">
                    </mat-form-field>                 
                    
                    <div>
                        
                            <div class="header-filter-log">
                                <mat-form-field class="area-height">
                                    <mat-label>Justificativa</mat-label>
                                    <textarea matInput class="textareaJustificativa" type="text" maxlength="500"
                                        formControlName="justificativa"></textarea>
                                </mat-form-field>
                            </div>
                    </div>
                </form>
            </mat-card-content>

        </mat-card>
        
        <div>
        </div>
    </div>
    <div class="modal-actions" mat-dialog-actions align="end">
        <button mat-flat-button color="primary"
            (click)="salvar()">Salvar</button>
    </div>
</div>
